import {
  CadendarConsts,
  AptRequests,
  Rdv,
  RdvTypeValues,
} from "cadendar-shared";
import {
  aptRequestUsedAtom,
  useRdvPopupState,
  useSelectedAptRequest,
  useSelectedPatientIds,
} from "../../main/state/globalState";
import useRdvProposal from "../../ficheAppel/hooks/useRdvProposal";
import { trpc } from "../../main/components/trpc.ts";
import { useSetAtom } from "jotai";
import styles from "./AptRequestList.module.css";
import {Button} from "@/components/ui/button";

interface AptRequestListProps {
  patientId: string;
  onShowFicheAppel: () => void;
}

const AptRequestList = (props: AptRequestListProps) => {
  const { patientId } = props;
  // const aptRequests = useQuery(
  //   ["aptRequestList", patientId],
  //   () => getAptRequests(owner, patientId),
  //   { enabled: !!owner && !!patientId }
  // ).data;
  const { data: aptRequests } =
    trpc.aptRequest.getAllByPatientId.useQuery(patientId);

  const { onSelectAptRequestId } = useSelectedAptRequest();
  const { onOpenRdvPopup } = useRdvPopupState();
  const handleAptRequestView = (aptRequestId: string) => {
    onSelectAptRequestId(aptRequestId);
    onOpenRdvPopup("aptRequestEdit");
  };

  const [, { selectPatientId }] = useSelectedPatientIds();
  const {
    setDuree,
    setType,
    setObjet,
    setReminderChecked,
    setConfirmChecked,
    assignMotifsNums,
  } = useRdvProposal();

  const setAptRequestUsed = useSetAtom(aptRequestUsedAtom);
  const handleTakeAptRequest = (aptRequest: AptRequests) => {
    selectPatientId(aptRequest.patient_id);
    setAptRequestUsed(aptRequest.id);

    setDuree(aptRequest.duration);
    setObjet(aptRequest.object);
    setType(aptRequest.type as RdvTypeValues);
    setReminderChecked(aptRequest.reminder_checked);
    setConfirmChecked(aptRequest.confirm_checked);
    assignMotifsNums([]); //hack pour forcer strategor
    props.onShowFicheAppel();
  };

  const handleCreateLink = () => {
    onSelectAptRequestId(null);
    onOpenRdvPopup("aptRequestCreate");
  };
  return (
    <div className={styles.card}>
      <div className={styles.headerStyle}>
        <div className={styles.titleStyle}>Rdvs à prendre</div>
      </div>
      {aptRequests && aptRequests.length > 0 ? (
        <table className={styles.table}>
          <thead>
            <tr className={styles.tr}>
              <th className={styles.th}>Durée</th>
              <th className={styles.th}>Objet</th>
            </tr>
          </thead>
          <tbody id="aptRequestList">
            {aptRequests
              .filter((aptRequests) => !aptRequests.apt_id)
              .map((aptRequest) => (
                <tr key={aptRequest.id}>
                  <td className={styles.td}>{aptRequest.duration}</td>
                  <td className={styles.td}>{aptRequest.object}</td>
                  <td className={styles.td}>
                    <a
                      id="aptRequestEdit"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleAptRequestView(aptRequest.id)}
                    >
                      Editer
                    </a>
                  </td>
                  <td className={styles.td}>
                    {aptRequest.apt_id ? (
                      <span className="label label-success">Rdv déjà pris</span>
                    ) : (
                      <Button
                        onClick={() => handleTakeAptRequest(aptRequest)}
                        id="aptRequestTake"
                        size="xs"
                        variant="secondary"
                      >
                        Prendre le rdv
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <></>
      )}
      <div className={styles.spacer}>
        <Button onClick={handleCreateLink} size="sm">
          Créer un lien RDV à prendre
        </Button>
      </div>
    </div>
  );
};

export default AptRequestList;
